import React from 'react';
import { SeoTableContentfulModel } from 'src/api/models/SEOTable';
import SEOTable from 'app_previous/molecules/Standard/Shared/SEOTable/SEOTable';

export default function getDynamicSEOTable(tableProps: SeoTableContentfulModel): React.ReactNode {
  return (
    <SEOTable
      {...{
        ...tableProps.tableData,
        // Set colors as functions since it doesn't pulls palette keys, but string css colors
        backgroundColorSet: tableProps.tableData.backgroundColorSet.map((color) => () => color as string),
        borderColor: () => tableProps.tableData.borderColor,
        textColor: () => tableProps.tableData.textColor,
      }}
    />
  );
}
